export type Safe<T> =
	| {
			ok: true
			value: T
	  }
	| {
			ok: false
			error: string
	  }

export function toSafeOk<T = unknown>(value: T): Safe<T> {
	return {
		ok: true,
		value
	}
}

export function toSafeError(error: string): Safe<never> {
	return {
		ok: false,
		error
	}
}

export function unwrap<T = unknown>(safe: Safe<T>): T | string {
	if (safe.ok) {
		return safe.value
	}

	return safe.error
}
